import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEmployeesFetchedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYEES_FETCHED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/5d77f95207085632a58945c3/employees',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            validationErrors: [
                {
                    instancePath: '/lastName',
                    schemaPath: '#/properties/lastName/minLength',
                    keyword: 'minLength',
                    params: {
                        limit: 1
                    },
                    message: 'must NOT have fewer than 1 characters',
                    value: '',
                    data: {
                        employmentStatus: 'active',
                        startDate: '2022-11-15T00:00:00.000Z',
                        firstName: 'John',
                        lastName: '',
                        incomeType: 'hourly',
                        payCycle: 'monthly',
                        dateOfBirth: '1983-10-10T00:00:00.000Z',
                        email: 'john.doe@email.com',
                        phone: '8011112222',
                        homeAddress: {
                            line1: '9839 White Ave.',
                            city: 'Hilliard',
                            zipcode: '43026',
                            state: 'OH',
                            country: 'USA'
                        }
                    }
                }
            ]
        }
    };
};
//# sourceMappingURL=employees-fetched.js.map